import React from 'react';
import './style.css';

import SubModuleSelector from '@submodules/SubModuleSelector';
import { getClasses } from '@utils';

type ContainerGridProps = {
  item: {
    contentful_id: string;
    classes: string;
    type: string;
    background: string;
    modules: ModuleProps[];
    moduleName: string;
  };
};

const ContainerGrid = ({ item }: ContainerGridProps): JSX.Element => {
  const { classes = '', type, background, modules: submodules, moduleName } = item;

  const containerClasses = getClasses(`container-grid--main`, classes, `is-bg-${background}`);

  const containerInnerClasses = getClasses(`container-grid__inner`, type && `container-grid--${type}`);

  return (
    <div id={moduleName} className={containerClasses}>
      <section className={containerInnerClasses}>
        <SubModuleSelector submodules={submodules} />
      </section>
    </div>
  );
};

export default ContainerGrid;
